// extracted by mini-css-extract-plugin
module.exports = {"container":"translateTrigger_container__ajY9S"};